import { cn } from "@/lib/utils";

interface FieldPlaceholderProps {
  text: string;
  isTitle?: boolean;
}

export function FieldPlaceholder({ text, isTitle = false }: FieldPlaceholderProps) {
  return (
    <div
      data-field-placeholder=""
      contentEditable={false}
      draggable={false}
      aria-hidden="true"
      className={cn(
        "document-field-chrome document-field-placeholder pointer-events-none [grid-area:1/1]",
        isTitle
          ? "text-[28px] font-semibold leading-tight text-muted-foreground/30"
          : "text-sm leading-6 text-muted-foreground/50"
      )}
    >
      {text}
    </div>
  );
}
